export class NewInventoryAdjustment {
    isbn!: string
    comment!: string
    quantity!: number
}